import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL } from "@/lib/legal";

export function LegalPage({ title, children }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-black/[0.05]">
        <div className="max-w-3xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-back-home">
            <ArrowLeft className="w-4 h-4" />
            <span className="font-display text-base leading-none">
              <span className="font-black">strato</span>
              <span className="font-normal text-foreground/55 ml-1 text-xs">by abstudio</span>
            </span>
          </Link>
          <span className="text-xs text-foreground/55">Vigente desde {LEGAL.effectiveDate}</span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-[-0.03em] mb-10">{title}</h1>
        <div className="prose prose-neutral max-w-none text-[15px] leading-relaxed text-foreground/80 space-y-5 [&_h2]:font-display [&_h2]:font-black [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-foreground [&_h2]:tracking-[-0.02em] [&_h3]:font-display [&_h3]:font-black [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-foreground [&_ul]:my-3 [&_ul]:pl-6 [&_ul]:list-disc [&_li]:my-1.5 [&_strong]:text-foreground [&_a]:text-foreground [&_a]:underline">
          {children}
        </div>
        <div className="mt-16 pt-8 border-t border-black/[0.06] text-xs text-foreground/55">
          <p><strong className="text-foreground">{LEGAL.legalName}</strong> · {LEGAL.country}</p>
          <p className="mt-1">Contacto: <a href={`mailto:${LEGAL.contactEmail}`} className="underline">{LEGAL.contactEmail}</a></p>
          <p className="mt-1">Dominio: {LEGAL.domain}</p>
        </div>
      </main>
    </div>
  );
}
